import { useContext, useEffect, useState } from 'react'
import { fetchJobDetail } from "../../services/Candidate Portal/fetchJobsApi"
import { useParams } from 'react-router-dom'
import { renderImgUrl } from "../../utils/renderImgUrl"
import { FiMapPin, FiClock } from "react-icons/fi";
import { IoBriefcaseOutline, IoBookmark, IoBookmarkOutline } from "react-icons/io5";
import { AiOutlineDollar } from "react-icons/ai";
import { GoPeople, GoDotFill } from "react-icons/go";
import { RiProgress5Line } from "react-icons/ri";
import { toggleJobSave, applyJob } from "../../services/Candidate Portal/jobApplications"
import { getHiringStatusClass } from "../../utils/Candidate Portal/JobList"
import { CiCalendarDate } from "react-icons/ci";
import { DataProvider } from '../../store/ContextProvider';
import Loading from '../../pages/Loading';
import MetaData from '../MetaData';
import { updateJobViewCount } from '../../services/Candidate Portal/JobViewCount';
import { RiShareFill } from "react-icons/ri";
import { JobApplyPopup } from '../../layouts/ui/JobApplyPopup';


function Jobs() {
    const { slug } = useParams()
    const { BeURL, isAuth, currentUser, showAlert, setJobId, setStatus, setApply, setSavingJob } = useContext(DataProvider)
    const [job, setJob] = useState(null)
    const [application, setApplication] = useState(null)
    const [savedIds, setSavedIds] = useState([]);
    const [appliedIds, setAppliedIds] = useState([]);
    const [saveLoader, setSaveLoader] = useState({ id: "", status: false })
    const [applyLoader, setApplyLoader] = useState({ id: "", status: false })
    const [expandDescription, setExpandDescription] = useState(false)

    const [popup, setPopup] = useState(false)

    const jobType = {
        ft: "Full time",
        pt: "Part time",
        contract: "Contract"
    }

    useEffect(() => {
        if (slug && BeURL) {
            fetchJobDetail(BeURL, showAlert, slug, setJob, setApplication)
        }
    }, [slug, BeURL])

    useEffect(() => {
        if (BeURL && currentUser && job?._id && currentUser.role === "job-seeker") {
            updateJobViewCount(BeURL, job._id, showAlert)
        }
    }, [BeURL, currentUser, job])

    const handleJobSaveToggle = (id, isSaving) => {
        if (isAuth) {
            toggleJobSave(BeURL, showAlert, id, isSaving, "dashboard", setSaveLoader, setSavedIds)
        }
        else {
            setPopup(true)
            setJobId(id)
            setSavingJob(isSaving)
            setApply("dashboard")
            setStatus("save")
        }
    }

    const handleJobApplication = (id) => {
        if (isAuth) {
            applyJob(BeURL, showAlert, id, setApplyLoader, setAppliedIds)
        }
        else {
            setPopup(true)
            setJobId(id)
            setStatus("apply")
        }
    }


    const renderSmLoader = () => {
        return (
            <div role="status">
                <svg aria-hidden="true" className="w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                </svg>
                <span class="sr-only">Loading...</span>
            </div>
        )
    }

    const isJobSaved = () => (application.saveStatus || savedIds.includes(job._id)) ? true : false
    const isJobApplied = () => (application.applicationStatus || appliedIds.includes(job._id)) ? true : false

    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: document.title,  // Title of the page you want to share
                    text: "Check out this job from CareerConnect Ai!",  // Custom message
                    url: window.location.href,  // The URL of the current page
                });
            } catch (error) {
                console.error("Error sharing:", error);
            }
        } else {
            // Fallback for browsers that don't support the Web Share API
            showAlert("Web Share API is not supported on this browser.");
        }
    }

    if (!slug || !job || !application) {
        return <Loading />
    }

    const infoCards = [
        {
            icon: IoBriefcaseOutline,
            title: "Experience",
            value: (job.experience?.min && job.experience?.max) ? (job.experience?.min + ' - ' + job.experience?.max + ' Years') : "",
            color: "text-blue-600"
        },
        {
            icon: AiOutlineDollar,
            title: "Salary",
            value: (job.salary?.min && job.salary?.max) ? ('₹ ' + job.salary?.min + ' LPA - ₹ ' + job.salary?.max + ' LPA') : "",
            color: "text-purple-600"
        },
        {
            icon: GoPeople,
            title: "Openings",
            value: job.openingsCount || "",
            color: "text-green-600"
        },
        {
            icon: CiCalendarDate,
            title: "Posted On",
            value: job.createdAt ? new Date(job.createdAt).toLocaleDateString("en-GB") : "",
            color: "text-teal-500"
        },
        {
            icon: RiProgress5Line,
            title: "Deadline",
            value: job.deadline ? new Date(job.deadline).toLocaleDateString("en-GB") : "",
            color: "text-orange-500"
        }
    ]

    return (
        <>

            <MetaData
                title={`${job.title} Job in ${job.location.city} | CareerConnect AI`}
                description={job.description.replace(/<[^>]*>?/gm, "").slice(0, 160)}
                keywords={`${job.title}, ${job.title} jobs, ${job.location.city} jobs, ${job.industry} jobs, CareerConnect AI, ${job.title} jobs in ${job.location.city}`}
                url={`https://www.careerconnectai.com/jobs/${job.slug}`}
                job={job}
            />

            <div className="py-6 min-h-[70vh] bg-[#F8F8F8] px-4 sm:px-6 md:px-10 lg:px-20 xl:px-32 2xl:px-40">

                <div className='p-5 py-6 rounded-xl shadow-sm flex flex-wrap md:flex-nowrap items-center justify-between my-3 bg-white'>
                    <div className='flex flex-col justify-center md:justify-start w-full md:w-auto'>
                        <div className='my-2 flex items-center justify-center md:justify-start gap-3'>
                            <img className="aspect-square object-contain w-[60px] md:w-[80px] rounded-full shadow" src={job.clientLogo || renderImgUrl(BeURL, job.createdBy.companyLogo, job.createdBy.companyName)} alt={job.createdBy.companyName || ""} />
                            <div className='my-1'>
                                <h2 className='font-semibold text-lg'>{job.title || "N/A"}</h2>
                                <p className='font-medium text-primary-500'>
                                    {job.client || "Top MNC"}
                                </p>
                                {/* <p className='font-medium text-primary-200 cursor-pointer' onClick={() => window.open(`/employer/${job.createdBy._id}`)}>
                                    {job.createdBy.companyName}
                                </p> */}
                            </div>
                        </div>
                        <div className='text-slate-700 flex flex-wrap gap-3 items-center my-2 w-full md:w-auto justify-center md:justify-start'>
                            <span className='flex gap-2 items-center'>
                                <FiMapPin className='text-primary-300 text-xl' />
                                {job.location?.city || "N/A"}
                            </span>
                            <span className='flex gap-1 items-center'>
                                <FiClock className='text-primary-300 text-xl' />
                                {jobType[job.employmentType] || "N/A"}
                                <GoDotFill className='text-xs' />
                                {job.location?.type || ""}
                            </span>
                        </div>
                    </div>
                    <div className='flex flex-wrap gap-3 my-3 w-full md:w-fit justify-center md:justify-end'>
                        <div className='flex w-full sm:w-auto items-center gap-3 justify-center sm:justify-start'>
                            <button
                                onClick={handleShare}
                                className="p-2 rounded-full text-primary-300 hover:text-white hover:bg-primary-400 focus:outline-none"
                                aria-label="Share this page"
                            >
                                <RiShareFill size={24} />
                            </button>
                            <button className={`
                            px-6 py-2 flex-1 sm:flex-none rounded-lg min-w-fit flex gap-3 items-center justify-center cursor-pointer
                            ${isJobSaved() ? "bg-primary-300 text-white" : "text-primary-300 border border-primary-300"}
                        `}
                                onClick={() => handleJobSaveToggle(job._id, (isJobSaved() ? false : true))}
                            >
                                {
                                    (saveLoader.id === job._id && saveLoader.status) ?
                                        renderSmLoader() :
                                        (isJobSaved() ? <><IoBookmark /> Remove from Bucket</> : <><IoBookmarkOutline /> Add to Bucket</>)
                                }

                            </button>
                        </div>
                        {
                            isJobApplied() ?
                                <div className={`
                                px-3 py-2 rounded-lg w-full sm:w-auto font-medium flex items-center justify-center
                                ${getHiringStatusClass(application.hiringStatus)}
                            `}>
                                    {application.hiringStatus}
                                </div>
                                :
                                <button className={`
                        px-6 py-2 w-full sm:w-auto rounded-lg bg-primary-300 text-white min-w-fit 
                        ${isJobApplied() ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
                        `}
                                    disabled={isJobApplied()}
                                    onClick={() => handleJobApplication(job._id)}
                                >
                                    {
                                        (applyLoader.id === job._id && applyLoader.status) ?
                                            "Applying..." :
                                            (isJobApplied() ? "Applied" : "Apply")
                                    }
                                </button>
                        }
                    </div>
                </div>

                <div className='grid grid-cols-1 min-[275px]:grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 my-3'>
                    {
                        infoCards.map((card, i, filteredArray) => {
                            if (card.value) {
                                const renderedCards = infoCards.filter(c => c.value);
                                const isLastCard = i === renderedCards.length - 1;
                                const isOddCount = renderedCards.length % 2 !== 0;
                                const shouldSpan = isLastCard && isOddCount;

                                return (
                                    <div className={`p-5 py-6 rounded-xl shadow-sm text-center bg-white ${shouldSpan ? 'min-[275px]:col-span-2 sm:col-span-1' : ''}`} key={i}>
                                        <div className='flex justify-center'>
                                            <card.icon className={`${card.color + " text-3xl"}`} />
                                        </div>
                                        <h3 className='font-medium my-2'>{card.title || "N/A"}</h3>
                                        <p className='text-slate-700 text-sm'>{card.value || "N/A"}</p>
                                    </div>
                                )
                            }
                            else return null
                        })
                    }
                </div>

                {
                    job.description &&
                    <div className='p-5 py-6 rounded-xl shadow-sm my-3 bg-white'>
                        <h3 className='font-medium my-2'>Job Description</h3>
                        <div className={`break-words overflow-hidden ${!expandDescription ? 'line-clamp-6' : ''}`} dangerouslySetInnerHTML={{ __html: job.description || "N/A" }} />
                        <button
                            onClick={() => setExpandDescription(!expandDescription)}
                            className='text-primary-300 hover:text-primary-400 font-medium mt-3'
                        >
                            {expandDescription ? 'Read Less' : 'Read More'}
                        </button>
                    </div>
                }

                <div className='p-5 py-6 rounded-xl shadow-sm my-3 bg-white'>
                    <h3 className='font-medium my-2'>Skills Required</h3>
                    <div className='flex flex-wrap gap-3'>
                        {
                            job.skills?.length &&
                            job.skills.map((skill, i) => (
                                <span className='bg-purple-50 text-secondary-300 shadow shadow-purple-200 rounded-xl px-4 py-1 text-sm' key={i}>{skill}</span>
                            ))
                        }
                    </div>
                </div>

                {
                    job.createdBy?.description &&
                    <div className='p-5 py-6 rounded-xl shadow-sm my-3 bg-white'>
                        <h3 className='font-medium my-2'>Why apply via CareerConnect AI?</h3>
                        <ul className='list-disc text-slate-800 space-y-1 ms-5 mt-3'>
                            <li>When you apply through <b className='font-semibold'>CareerConnect AI</b>, your profile doesn’t just reach a company, it reaches the right people.</li>
                            <li>Every job listed here is <b className='font-semibold'>verified</b>, and every application is tracked till response.</li>
                            <li>You stay connected, informed, and in control of your job search.</li>
                            <li>No fake openings, just <b className='font-semibold'>genuine opportunities</b> that move you forward.</li>
                            <li>That’s why candidates trust CareerConnect AI to take their next career step.</li>
                        </ul>
                    </div>
                }

                <div className='p-5 py-6 rounded-xl shadow-sm my-3 text-center bg-gradient-to-r from-blue-100 from-20% via-purple-100 to-purple-50'>
                    <h3 className='my-2 text-xl font-medium'>Your Career journey starts here!</h3>
                    <p className='my-3 text-slate-700'>We're looking for motivated professionals who are ready to contribute and grow with us.</p>
                    <div className='flex justify-center'>
                        <button className={`
                        px-6 py-2 bg-primary-300 font-medium text-white rounded-xl
                        ${isJobApplied() ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
                        `}
                            disabled={isJobApplied()}
                            onClick={() => handleJobApplication(job._id)}
                        >
                            {
                                (applyLoader.id === job._id && applyLoader.status) ?
                                    "Applying..." :
                                    (isJobApplied() ? "Applied" : "Apply now")
                            }
                        </button>
                    </div>
                </div>
            </div>
            {popup && (
                <JobApplyPopup setPopup={setPopup} />
            )}
        </>
    )
}
export default Jobs